<template>
    <div>
        <div class="col-lg-8 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in items"
                    :key="item.id"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col-3 pl-4 border-right">
                                <input type="text" placeholder="from" v-model="item.from">
                            </div>
                            <div class="col-3 border-right">
                                <input type="text" placeholder="to" v-model="item.to">
                            </div>
                            <div class="col">
                                <input type="text" placeholder="fee" v-model="item.fee">
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            :iconName="$t('general.clone')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.remove')"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add"
            :title="$t('general.add')"
        >
    </div>
</template>

<script>
import Services from '@/services/Services'
import Service from '@/services/hatsApi/Service'
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  data () {
    return {
      items: {},
      searchQuery: null
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  created () {
    this.type = this.$route.params.type
    Services.getCancelations({query: this.searchQuery}).then((response) => {
      this.items = response.data
    })
  },
  methods: {
    async submit () {
      // Todo: Create record
      let response = await Service.createServiceType(this.items)
      if (response.data.id) {
        this.$router.push({path: '/services/' + this.type + '/' + response.data.id + '/info/cancellations'})
      }
    },
    submitAndClose () {
      this.submit()
    }
  }
}
</script>

<style>
    .input-table .input-table-content {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/CancelationsInputTable.vue